module.exports = __webpack_public_path__ + "img/AGRO01.4329fb2c.png";